<ng-container matColumnDef="actions">
  <th *matHeaderCellDef mat-header-cell></th>
  <td *matCellDef="let row" mat-cell>
    <button
      mat-icon-button
      ixTest="toggle-row"
      [matTooltip]="expandedRow === row ? ('Collapse Row' | translate) : ('Expand Row' | translate)"
      [attr.aria-label]="expandedRow === row ? ('Collapse Row' | translate) : ('Expand Row' | translate)"
      (click)="$event.stopPropagation(); onClick(row)"
    >
      <ix-icon [name]="expandedRow === row ? 'expand_less' : 'expand_more'"></ix-icon>
    </button>
  </td>
</ng-container>
